import axios from 'axios'
import cookies from 'vue-cookie'

export default {
  user: {
    authenticated: false
  },
  login(next) {
    if (this.user.authenticated) {
      next()
    } else {
      console.log('redirecting to mystique ...')
      axios.get(process.env.API_URL + 'auth/configuration').then(response => {
        var path = response.data.authorizationUrl + '?client_id=' + response.data.clientId + '&response_type=code&redirect_uri=' + encodeURIComponent(response.data.redirectCallbackUri)
        window.location.href = path
      })
    }
  },
  logout() {
    axios.get(process.env.API_URL + 'auth/configuration').then(response => {
      var path = response.data.logoutUri + '?redirect_uri=' + encodeURIComponent(response.data.redirectUri)
      cookies.delete('portal_cjp_jwt', {domain: 'portal.mutantcxo.com'})
      window.location.href = path
    })
    this.user.authenticated = false
  },
  checkAuth() {
    var cookieJwt = cookies.get('portal_cjp_jwt')
    if (cookieJwt) {
      this.user.authenticated = true
    } else {
      this.user.authenticated = false
    }
  },
  getToken() {
    const data = cookies.get('portal_cjp_jwt').split('.')[1]
    const payload = JSON.parse(atob(data))
    return btoa(`${payload.accessId}:${payload.secretKey}`)
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js